import AudioCallGame from './AudioCallGame';

export default AudioCallGame;
